<script>
  import Modal from '@components/general/modal.svelte'
  import Button from '@components/buttons/button.svelte'
  import Form from '@components/forms'
  import ColorPicker from '@components/general/color-picker.svelte'
  import { useForm } from '@inertiajs/svelte'
  import { Save } from 'lucide-svelte'

  let { tag, open = $bindable(false), onClose, onSuccess } = $props()

  let isCreate = $derived(!tag)
  let title = $derived(isCreate ? "New tag" : `Edit tag: ${tag.name}`)

  const CONTEXTS = [
    { value: 'resource', label: 'Resource' },
    { value: 'video', label: 'Video' },
    { value: 'live_session', label: 'Live session' },
  ]

  const form = $derived(useForm({
    name: tag?.name || '',
    color: tag?.color || '',
    context: tag?.context || 'resource',
  }))

  function handleSuccess() {
    onSuccess?.()
    open = false
  }

  function handleSubmit(e) {
    e.preventDefault()
    if (isCreate) {
      $form.post('/admin/tags', { onSuccess: handleSuccess })
    } else {
      if (!$form.isDirty) return handleSuccess()
      $form.patch(`/admin/tags/${tag.id}`, { onSuccess: handleSuccess })
    }
  }
</script>

<Modal {title} width="40rem" bind:open {onClose}>

  <Form.Element {form} id="tag-form" onsubmit={handleSubmit}>

    <Form.Items>

      <!-- Name: editable on create, read-only on edit -->
      {#if isCreate}
        <Form.Item name="name" bind:value={$form.name} label="Name" cols={12} required />
      {:else}
        <Form.Item name="name" value={tag.name} label="Name" disabled cols={12} />
      {/if}

      <!-- Context: editable on create only -->
      {#if isCreate}
        <Form.Item name="context" label="Context" type="select" bind:value={$form.context} cols={12} options={CONTEXTS} required />
      {/if}

      <Form.Item name="color" bind:value={$form.color} label="Color" hint="The color of the tag" cols={12}>
        <ColorPicker bind:color={$form.color} width="100%" buttonProps={{ class: "w-full h-[42px]" }} />
      </Form.Item>

    </Form.Items>

  </Form.Element>

  {#snippet footer()}
    <Button type="submit" form="tag-form" text={isCreate ? "Create tag" : "Save"} variant="submit" Icon={Save} loading={$form.processing} />
  {/snippet}
  
</Modal>
